import dayjs from "dayjs";
import { KeyReturnAdrKb } from "~/extensions/utils/DefineTypes";
import { isNullOrUndefined } from "~/extensions/utils/DefineFunction";
export function updateKaiyakuYmd(taikyo) {
    const taikyoYmd = taikyo.taikyoYmd;
    const monthLater = taikyo.shinseiYmd ? dayjs(taikyo.shinseiYmd).startOf("day").add(1, "month") : dayjs().startOf("day").add(1, "month");
    if (taikyoYmd == null || !dayjs(taikyoYmd).isValid()) {
        taikyo.kaiyakuYmd = null;
    }
    else if (monthLater.isAfter(taikyoYmd)) {
        taikyo.kaiyakuYmd = dayjs(taikyoYmd).date() > monthLater.date() ? monthLater.toDate() : monthLater.subtract(1, "day").toDate();
    }
    else {
        taikyo.kaiyakuYmd = dayjs(taikyoYmd).toDate();
    }
}
export function updateKeyReturnDateTime(row) {
    const hasDate = row.keyReturnStrYmd !== "" && !isNullOrUndefined(row.keyReturnStrYmd);
    const hasTime = row.keyReturnStrTime !== "00:00" && !isNullOrUndefined(row.keyReturnStrTime);
    row.keyReturnYmd = hasDate && hasTime ? `${row.keyReturnStrYmd} ${row.keyReturnStrTime}` : hasDate ? `${row.keyReturnStrYmd}` : hasTime ? `${row.keyReturnStrTime}` : "";
}
export function clearContactFields(row) {
    row.renrakuName = null;
    row.renrakuRelationship = null;
    if (row.renrakuKb === null) {
        row.tel = null;
        row.email = null;
    }
}
export function clearReturnAddressFields(row, personal) {
    row.soufuName = null;
    row.postCode = null;
    row.adr1 = null;
    row.adr2 = null;
    row.adr3 = null;
    row.soufuSonota = null;
    if (row.keyReturnAdrKb === KeyReturnAdrKb.Hojin) {
        row.postCode = personal.mailPostcode;
        row.adr1 = personal.mailAdr1;
        row.adr2 = personal.mailAdr2;
        row.adr3 = personal.mailAdr3;
    }
    else if (row.keyReturnAdrKb === KeyReturnAdrKb.Nyukyosha) {
        const keiyaku = personal.nyukyokeiyakuList.find((item) => item.orgNyukyokeiyakuNo === row.taikyoNo);
        row.soufuName = keiyaku?.nyukyosha;
        row.postCode = keiyaku?.postCode;
        row.adr1 = keiyaku?.adr1;
        row.adr2 = keiyaku?.adr2;
        row.adr3 = `${keiyaku?.bukkenName ?? ""}${keiyaku?.roomNumber ?? ""}`;
    }
}
